<template>
    <li class="category-filter">
        <hh-label :for-def="defKey"
                  :tabstop="true"
                  class="category-filter__label">
            <hh-checkbox :def="defKey"
                         class="category-filter__checkbox"
                         v-model="internalValue"
                         :tabstop="false"
                         @change="onChange" />
            {{ displayText }}
        </hh-label>
    </li>
</template>

<script>

export default {

    props: {
        prefix: {
            type: String,
            required: true,
        },
        segment: {
            type: Object,
            required: true,
        },
        value: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            internalValue: this.value,
        }
    },

    watch: {

        value(newValue) {
            this.internalValue = newValue
        },
    },

    computed: {

        defKey() {
            return `${ this.prefix }-chk-${ this.segment.key }`
        },

        displayText() {
            return this.segment.text
        },
    },

    methods: {

        onChange(value) {
            this.internalValue = value
            this.$emit('change', { key: this.segment.key, text: this.segment.text, show: this.internalValue })
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_category-filter.scss

.category-filter {
    cursor: pointer;

    * {
        cursor: pointer !important;
        @include user-select-none;
    }
}

</style>
